export default __webpack_public_path__ + "static/media/forgot_pq.3c3e1b7b.jpg";